// The brands of the cloud, secret and VCS providers we integrate with - never env0's own. They
// identify a third party, so they must not move when our palette does, which makes this file the
// single exception to the raw-color lint ban in eslint.config.mjs.
//
// Two entries per provider where the product already uses two shades. Do not collapse them -
// reconciling the palettes is a restyle decision, not a constants one.
export const PROVIDER_BRAND_COLORS = {
  AWS_ORANGE: '#FF9900',
  AZURE_BLUE: '#0080FF',
  AZURE_PURPLE: '#5f0e6b',
  GCP_GREEN: '#34A853',
  GCP_BLUE: '#4285F4',
  VAULT_YELLOW: '#FFCF25',
  ORACLE_RED: '#BF0202'
} as const;
